// extracted by mini-css-extract-plugin
export default {"contactMethods":"styles_contactMethods__gpy29","icon":"styles_icon__DD1O5","label":"styles_label__LteHD"};